import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const CustomDetailsTabPanel = ({
    children,
    index,
    value,
    ...other
}: TabPanelProps): React.JSX.Element => {
    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
};

export default CustomDetailsTabPanel;
